import { useEffect, useRef } from "react";

/**
 * Consume a one-shot `?action=` search param, as set by a sign-in redirect.
 * Strips it from the URL on mount so a refresh doesn't re-trigger it, and
 * calls `startEditing` once when the action is "edit" and `ready` turns true.
 */
export function useEditActionParam(
  action: string | undefined,
  ready: boolean,
  startEditing: () => void,
) {
  const initialActionRef = useRef(action);
  const hasAutoTriggeredEdit = useRef(false);

  useEffect(() => {
    if (!initialActionRef.current) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete("action");
      window.history.replaceState({}, "", url.toString());
    } catch {
      // May fail in some environments
    }
  }, []);

  useEffect(() => {
    if (
      initialActionRef.current === "edit" &&
      ready &&
      !hasAutoTriggeredEdit.current
    ) {
      hasAutoTriggeredEdit.current = true;
      startEditing();
    }
  }, [ready, startEditing]);
}
